import { render, staticRenderFns } from "./SelectionModal.vue?vue&type=template&id=ef207b5c&scoped=true&lang=pug&"
import script from "./SelectionModal.vue?vue&type=script&lang=js&"
export * from "./SelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectionModal.vue?vue&type=style&index=0&id=ef207b5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef207b5c",
  null
  
)

export default component.exports